// ===================================================
// File: src/hooks/useToast.js
// ===================================================
import { useState } from 'react';

const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (config) => {
    const id = Date.now() + Math.random();
    const newToast = {
      id,
      title: config.title || 'Notification',
      message: config.message || 'This is a toast message.',
      type: config.type || 'success',
      icon: config.icon || '',
      duration: config.duration || 5000
    };
    setToasts(prev => [...prev, newToast]);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  return { toasts, showToast, removeToast };
};

export default useToast;